import { ReactNode } from 'react'

import { ProductCatalogTabId } from 'const/productCatalog'
import { CellRenderProps, CountryCode, ProductMetadataGroupBy } from 'types'

import ProductTitle from '../ProductTitle'

interface ProductTitleCellProps<RecordType>
    extends Pick<CellRenderProps<RecordType>, 'value'> {
    productImg?: string | null
    productAdId?: string
    profileCountryCode?: string
    showImage?: boolean
    productAsin?: string
    productMarketplace?: CountryCode
    linkToProductDetails?: boolean
    size?: 'large' | 'medium' | 'small'
    titleFormatter?: (value: ReactNode) => ReactNode
    onProductClick?: () => void
    productDetailsTabToLinkTo?: ProductCatalogTabId
}

function ProductCatalogTitleCell<RecordType extends ProductMetadataGroupBy>({
    value,
    productImg,
    showImage = true,
    productAsin,
    productMarketplace,
    linkToProductDetails = false,
    size = 'large',
    titleFormatter,
    onProductClick,
    productDetailsTabToLinkTo,
}: ProductTitleCellProps<RecordType>): ReactNode {
    return (
        <ProductTitle
            value={value}
            productImg={productImg}
            productAsin={productAsin}
            productMarketplace={productMarketplace}
            showImage={showImage}
            isLoading={value === 'Loading...'}
            linkToProductDetails={linkToProductDetails}
            size={size}
            titleFormatter={titleFormatter}
            onProductClick={onProductClick}
            productDetailsTabToLinkTo={productDetailsTabToLinkTo}
        />
    )
}

export default ProductCatalogTitleCell
